import React, { ReactNode } from 'react';
import { Body, Button, Center, Flex, ListSelector, ListSelectorValue } from '@cerebral-inc/design-system';
import { Question } from 'types/question';

export interface MutiSelectorContentProps {
  selections: ListSelectorValue[];
  openPopup: boolean;
  onSelect: (value: ListSelectorValue[]) => void;
  onOpenPopup: (value: boolean) => void;
  question: Question;
  isSingleSelect?: boolean;
  popUpText?: string;
  popUpComponent?({ isOpen, onClose }: { isOpen: boolean; onClose(): void }): ReactNode;
}

export const MutiSelectorContent = ({
  question,
  isSingleSelect,
  popUpText,
  selections,
  openPopup,
  popUpComponent,
  onOpenPopup,
  onSelect
}: MutiSelectorContentProps) => {
  const { subscript, options } = question;

  return (
    <>
      {subscript && (
        <Body size="small" textAlign="center" color="warmGray900" marginTop={8}>
          {subscript}
        </Body>
      )}

      {!isSingleSelect && (
        <Body size="small" textAlign="center" color="warmGray900" marginTop={subscript ? 0 : 8}>
          Select all that apply.
        </Body>
      )}

      <>
        <Flex paddingTop={34} gap={8} marginBottom={{ base: popUpText ? 0 : 32, md: 0 }}>
          <ListSelector
            options={options.map(item => ({ label: item.name, value: item.name }))}
            onChange={value => onSelect(value)}
            multiple
            value={selections}
          />
        </Flex>
        {popUpText && (
          <Center marginTop={32} marginBottom={{ base: 24, md: 0 }}>
            <Button
              onPress={() => {
                onOpenPopup(true);
              }}
              variant="tertiary"
            >
              {popUpText}
            </Button>

            {openPopup && popUpComponent && popUpComponent({ isOpen: openPopup, onClose: () => onOpenPopup(false) })}
          </Center>
        )}
      </>
    </>
  );
};
